/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.workflows').controller('WorkflowContextDetailViewController',
    function ($document, $routeParams, $window, WorkflowExecutionResourceFactory, NotificationService, ModalService, _) {
        var self = this;

        self.gridColumns = [
            {
                field: 'name',
                displayName: 'Name',
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'value',
                displayName: 'Value',
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            }
        ];

        self.gridOptions = {
            rowSelection: false,
            enableSorting: false,
            enableColumnMenus: false,
            enableFullRowSelection: false,
            enableRowHeaderSelection: false,
            rowHeight: 30,
            minRowsToShow: 5,
            columnDefs: self.gridColumns
        };

        self.getContextGridData = function () {
            self.gridOptions.data = WorkflowExecutionResourceFactory.getExecutionContextData({id: $routeParams.id});
        };

        self.getContextGridData();

        const getPreparedJsonData = () => {
            let jsonData = _.cloneDeep(self.gridOptions.data);

            _.unset(jsonData, '$resolved');
            _.unset(jsonData, '$promise');

            _.forEach(jsonData, (jsonNode) => {
                try {
                    _.unset(jsonNode, '$$hashKey');
                    jsonNode.value = JSON.parse(jsonNode.value);
                } catch (exception) {
                    console.warn(exception);
                }
            });

            return jsonData;
        };

        self.onCopyContextDataClicked = () => {
            const preparedJsonData = getPreparedJsonData(self.gridOptions.data);
            if (!_.isNil($window.navigator.clipboard)) {
                console.warn('Navigator available. Copying to clipboard using Clipboard API');
                $window.navigator.clipboard.writeText(JSON.stringify(preparedJsonData)).then(function () {
                    NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
                }, function () {
                    NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
                });
            } else {
                console.warn('Navigator not available. Copying to clipboard using document.execCommand');
                const input = $document.createElement('input');
                $document.body.appendChild(input);
                input.value = JSON.stringify(preparedJsonData);
                input.focus();
                input.select();
                const result = $document.execCommand('copy');
                input.remove();
                if (result) {
                    NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
                } else {
                    NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
                }
            }
        };

        self.showContextDataClicked = () => {
            ModalService.showJsonViewerModal(getPreparedJsonData(self.gridOptions.data));
        };
    });
